import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ef0fe6bc&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=ef0fe6bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef0fe6bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef0fe6bc')) {
      api.createRecord('ef0fe6bc', component.options)
    } else {
      api.reload('ef0fe6bc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ef0fe6bc&scoped=true&", function () {
      api.rerender('ef0fe6bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/payout/thirdOrder/index.vue"
export default component.exports